import { combine, createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { model as router } from '~/core/router'
import { profilesModel } from '~/entities/profiles'
import { model as session } from '~/entities/session'
import * as pinLockFeature from '~/features/pin-lock'
import { pinlockProfilesFeatureModel } from '~/features/pin-lock'

export const init = createEvent()

const backToSettings = createEvent()

sample({
  clock: backToSettings,
  fn: () => '/modules/settings',
  target: router.navigatePush,
})

register(backToSettings, 'settings/content/backToSettings')

//
// Protect Content with PIN Lock
//

const setPinLock = createEvent<{ value: boolean }>()

sample({
  clock: setPinLock,
  source: session.$session,
  filter: (_, { value }) => value,
  fn: (session) => session?.accountNumber || '',
  target: pinLockFeature.enable,
})

sample({
  clock: setPinLock,
  source: session.$session,
  filter: (_, { value }) => !value,
  fn: (session) => session?.accountNumber || '',
  target: pinLockFeature.disable,
})

const setProfilesPinLock = createEvent<{ value: boolean }>()

sample({
  clock: setProfilesPinLock,
  fn: ({ value }) => value,
  target: pinlockProfilesFeatureModel.toggle,
})

const $showProtectContentWithPinLock = combine(
  pinLockFeature.$isSettingsEnabled,
  (isPinLockInSettingsEnabled) => isPinLockInSettingsEnabled
)

export const $showProfileSwitchLocked = combine(
  profilesModel.$optimisticProfiles,
  (profiles) => profiles.some((profile) => profile.kidsProfile)
)

register(setPinLock, 'settings/content/pin-lock-set')
register(pinLockFeature.$enabled, '$settings/content/pin-lock-enabled')
register(setProfilesPinLock, 'settings/content/pin-lock-profiles-set')
register(
  pinlockProfilesFeatureModel.$enabled,
  '$settings/content/pin-lock-profiles-enabled'
)
register(
  $showProtectContentWithPinLock,
  '$settings/content/show-protect-content-with-pin-lock'
)
register(
  $showProfileSwitchLocked,
  '$settings/content/show-profile-switch-locked'
)

//
// Tranlations
//
